import { registerCommand } from '../registry';
import type { ScopedSearchCommandDef } from '../types';

/**
 * `/location <text>` — restrict search to address/place geocode hits.
 * Implemented as a scoped-search command so the slash host can run a
 * geocode-only executor and keep results inside the command palette.
 */
const locationCommand: ScopedSearchCommandDef = {
  id: 'location',
  kind: 'scopedSearch',
  scopedFilter: 'location',
  title: 'Search locations',
  description: 'Search addresses and places.',
  usage: '<address or place>',
};

registerCommand(locationCommand);

export default locationCommand;
